<template>
  <LoadingDiv v-if="isLoading" />

  <section v-else class="setup-complete-card">
    <span class="setup-complete-icon"><CircleCheck :size="26" /></span>
    <div class="setup-complete-heading">
      <h1>Setup completed</h1>
      <p>Your administration workspace is ready. Keep the initial credentials secure and change them after signing in.</p>
    </div>

    <div class="setup-credential-grid">
      <div>
        <span>Master administrator</span>
        <strong>admin</strong>
      </div>
      <div>
        <span>Initial password</span>
        <strong>hYudg5$4op</strong>
      </div>
    </div>

    <div class="setup-complete-note">
      <Info :size="17" />
      <span>These credentials provide initial access to the local administration workspace.</span>
    </div>

    <footer class="setup-complete-actions">
      <button type="button" @click="handleNext">
        Continue to sign in
        <ArrowRight :size="17" />
      </button>
    </footer>
  </section>
</template>

<script>
import { ref } from "vue";
import { ArrowRight, CircleCheck, Info } from "@lucide/vue";
import LoadingDiv from "@/components/LoadingDiv.vue";

export default {
  name: "FinalSetupComponent",
  components: { ArrowRight, CircleCheck, Info, LoadingDiv },
  emits: ["next"],
  setup(props, context) {
    const isLoading = ref(false);
    const error = ref(null);
    const handleNext = () => context.emit("next", { step: 7, isComplete: true });

    return { error, handleNext, isLoading };
  },
};
</script>

<style scoped>
.setup-complete-card {
  align-items: center;
  background: var(--ui-card);
  border: 1px solid var(--ui-border);
  border-radius: var(--ui-radius);
  box-shadow: var(--ui-shadow-xs);
  color: var(--ui-card-foreground);
  display: flex;
  flex-direction: column;
  padding: 2.5rem;
  text-align: center;
}
.setup-complete-icon { align-items: center; background: color-mix(in srgb, var(--ui-success) 10%, var(--ui-background)); border-radius: 999px; color: var(--ui-success); display: flex; height: 3.5rem; justify-content: center; width: 3.5rem; }
.setup-complete-heading { max-width: 34rem; }
.setup-complete-heading h1 { font-family: var(--ui-font-display); font-size: 1.35rem; margin: 1rem 0 0; }
.setup-complete-heading p { color: var(--ui-muted-foreground); line-height: 1.55; margin: .5rem 0 0; }
.setup-credential-grid { display: grid; gap: 1rem; grid-template-columns: repeat(2, minmax(0, 1fr)); margin-top: 2rem; max-width: 36rem; width: 100%; }
.setup-credential-grid > div { background: var(--ui-muted); border: 1px solid var(--ui-border); border-radius: var(--ui-radius); display: grid; gap: .45rem; padding: 1rem; text-align: left; }
.setup-credential-grid span { color: var(--ui-muted-foreground); font-size: .72rem; }
.setup-credential-grid strong { font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-size: .9rem; }
.setup-complete-note { align-items: center; color: var(--ui-muted-foreground); display: flex; font-size: .76rem; gap: .5rem; margin-top: 1.25rem; }
.setup-complete-actions { border-top: 1px solid var(--ui-border); margin-top: 2rem; padding-top: 1.25rem; width: 100%; }
.setup-complete-actions button { align-items: center; background: var(--ui-primary); border: 1px solid var(--ui-primary); border-radius: calc(var(--ui-radius) - 2px); color: var(--ui-primary-foreground); display: inline-flex; font: inherit; font-size: .82rem; font-weight: 600; gap: .5rem; min-height: 2.6rem; padding: 0 1rem; }
@media (max-width: 600px) {
  .setup-complete-card { padding: 1.5rem 1rem; }
  .setup-credential-grid { grid-template-columns: 1fr; }
  .setup-complete-actions button { width: 100%; justify-content: center; }
}
</style>
